export const appLocales = ["en", "zh"] as const;

export type AppLocale = (typeof appLocales)[number];

export const defaultLocale: AppLocale = "en";

export const isAppLocale = (value: string | undefined): value is AppLocale =>
  appLocales.some((locale) => locale === value);

export const normalizeLocale = (value: string | null | undefined): AppLocale =>
  value != null && isAppLocale(value) ? value : defaultLocale;
